import { render } from "./DoctorScheduleModal.vue?vue&type=template&id=2390fad7&scoped=true"
import script from "./DoctorScheduleModal.vue?vue&type=script&lang=js"
export * from "./DoctorScheduleModal.vue?vue&type=script&lang=js"

import "./DoctorScheduleModal.vue?vue&type=style&index=0&id=2390fad7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2390fad7"]])

export default __exports__